var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.875 5L0.9375 1.0625L2 0L7 5L2 10L0.9375 8.9375L4.875 5Z","fill":"#064861"}));
}

ChevronRight.defaultProps = {"width":"7","height":"10","viewBox":"0 0 7 10","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
